import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const AmendmentsToDollar = lazy(() =>
  import("Components/SecuritySupport/Advisory/AmendmentsToDollar")
);
const InterestRatesFAQ = lazy(() =>
  import("Components/SecuritySupport/FAQs/InterestRatesFAQ")
);
const CustomerInformationUpdate = lazy(() =>
  import("Components/SecuritySupport/Advisory/CustomerInformationUpdate")
);
const ClearingSystem = lazy(() =>
  import("Components/SecuritySupport/Advisory/ClearingSystem")
);
const CustomerCreditData = lazy(() =>
  import("Components/SecuritySupport/Advisory/CustomerCreditData")
);
const ForeignExchangeRates = lazy(() =>
  import("Components/SecuritySupport/Advisory/ForeignExchangeRates")
);
const BankingSecurity = lazy(() =>
  import("Components/SecuritySupport/BankingSecurity")
);
const CreditCardFeesAndCharges = lazy(() =>
  import("Components/SecuritySupport/CardFeesAndCharges")
);
const DepositFeesAndCharges = lazy(() =>
  import("Components/SecuritySupport/DepositFeesAndCharges")
);
const FAQs = lazy(() => import("Components/SecuritySupport/FAQs"));
const DebitCardRecarding = lazy(() =>
  import("Components/SecuritySupport/FAQs/DebitCardRecarding")
);
const LostCard = lazy(() =>
  import("Components/SecuritySupport/FAQs/StolenCard")
);
const TravelMoneyFAQ = lazy(() =>
  import("Components/SecuritySupport/FAQs/TravelMoneyFAQ")
);
const tutorials = lazy(() =>
  import("Components/SecuritySupport/FAQs/Tutorials")
);
const WarehouseFAQ = lazy(() =>
  import("Components/SecuritySupport/FAQs/WarehouseFAQ")
);
const LoansFeesAndCharges = lazy(() =>
  import("Components/SecuritySupport/LoansFeesAndCharges")
);
const PaymentChannels = lazy(() =>
  import("Components/SecuritySupport/PaymentChannels")
);
const SupportSearchResult = lazy(() =>
  import("Components/SecuritySupport/SupportSearchResult")
);
const DepositTerms = lazy(() =>
  import("Components/SecuritySupport/Terms/DepositTerms")
);
const DLSAAMasterCardRewards = lazy(() =>
  import("Components/SecuritySupport/Terms/DLSAAMasterCardRewards")
);
const electronicstatementofaccount = lazy(() =>
  import("Components/SecuritySupport/Terms/electronicstatementofaccount")
);
const HyundaiRebateProgram = lazy(() =>
  import("Components/SecuritySupport/Terms/HyundaiRebateProgram")
);
const travelinsurance = lazy(() =>
  import("Components/SecuritySupport/Terms/travelinsurance")
);
const TermsandConditions = lazy(() =>
  import("Components/SecuritySupport/TermsandConditions")
);

const SupportAndSecurityRoutes = () => {
  return (
    <Switch>
      <Route
        path="/supportandsecurity/termsandconditions/travelaccidentandinconvenienceinsurance"
        component={travelinsurance}
      />
      <Route
        path="/supportandsecurity/termsandconditions/dlsaamastercardrewards"
        component={DLSAAMasterCardRewards}
      />
      <Route
        path="/supportandsecurity/termsandconditions/hyundairebateprogram"
        component={HyundaiRebateProgram}
      />
      <Route
        path="/supportandsecurity/termsandconditions/electronicstatementofaccount"
        component={electronicstatementofaccount}
      />
      <Route
        path="/supportandsecurity/termsandconditions/depositterms"
        component={DepositTerms}
      />
      <Route
        path="/supportandsecurity/termsandconditions/:id"
        component={TermsandConditions}
      />
      <Route
        path="/supportandsecurity/advisory/customerinformationupdate"
        component={CustomerInformationUpdate}
      />
      <Route
        path="/supportandsecurity/Advisory/ForeignExchangeRates"
        component={ForeignExchangeRates}
      />
      <Route
        path="/supportandsecurity/advisory/amendmentstodollar"
        component={AmendmentsToDollar}
      />
      <Route
        path="/supportandsecurity/advisory/customercreditdata"
        component={CustomerCreditData}
      />
      <Route
        path="/supportandsecurity/frequentlyaskedquestions/clearingsystem"
        component={ClearingSystem}
      />
      <Route
        path="/supportandsecurity/paymentchannels"
        component={PaymentChannels}
      />
      <Route
        path="/supportandsecurity/feesandcharges/creditcards"
        component={CreditCardFeesAndCharges}
      />
      <Route
        path="/supportandsecurity/feesandcharges/personalloans"
        component={LoansFeesAndCharges}
      />
      <Route
        path="/supportandsecurity/feesandcharges/deposits"
        component={DepositFeesAndCharges}
      />
      <Route
        path="/supportandsecurity/frequentlyaskedquestions/onlinebankingvideotutorials"
        component={tutorials}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/warehouseaddresses"
        component={WarehouseFAQ}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/interestrates"
        component={InterestRatesFAQ}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/travelmoneycard"
        component={TravelMoneyFAQ}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/debitcardrecarding"
        component={DebitCardRecarding}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/:id"
        component={FAQs}
      />
      <Route
        path="/supportandsecurity/FrequentlyAskedQuestions/lostcard"
        component={LostCard}
      />
      <Route
        path="/supportandsecurity/bankingsecurity/:id"
        component={BankingSecurity}
      />{" "}
      <Route
        path="/supportandsecurity/search-results"
        component={SupportSearchResult}
      />
      <Route exact path="/supportandsecurity">
        <Redirect to="/tipsandtutorials" />
      </Route>
      <Route path="*">
        <Redirect to="/tipsandtutorials" />
      </Route>
    </Switch>
  );
};

export default SupportAndSecurityRoutes;
